<template>

    <div class="sidebar">

        <h3>Konfiguration der Druckfläche</h3>

        <p><b>Aufdruck:</b> {{ view.title }}</p>

        <p><b>Beschreibung:</b> {{ view.description }}</p>

        <p><b class="display-block">Daten:</b> Druckfläche: {{ view.printArea }}<br> Druckverfahren: {{ view.printType }}</p>

        <label class="configure-property">
            <span>Höhe (mm)</span>
            <input type="number" v-model.number="models.height" @input="rerenderCanvas"> <!--  :value="boundingBox.getScaledHeightInMm()" @input="eventHeightModified" -->
        </label>

        <label class="configure-property">
            <span>Breite (mm)</span>
            <input type="number" v-model.number="models.width" @input="rerenderCanvas"> <!-- :value="boundingBox.getScaledWidthInMm()" @input="eventWidthModified" -->
        </label>

        <label class="configure-property">
            <span>Faktor</span>
            <input type="number" v-model.number="models.factor" @input="rerenderCanvas">
        </label>

        <label class="configure-property">
            <span>Oben (in mm)</span>
            <input type="number" v-model="models.top" @input="rerenderCanvas">
        </label>

        <label class="configure-property">
            <span>Maximal Oben (in mm)</span>
            <input type="number" :value="models.maxTop" @input="eventMaxYModified">
        </label>

        <label class="configure-property">
            <span>Links (in mm)</span>
            <input type="number" v-model="models.left" @input="rerenderCanvas">
        </label>

        <label class="configure-property">
            <span>Maximal Links (in mm)</span>
            <input type="number" :value="models.maxLeft" @input="eventMaxXModified">
        </label>

        <a @click="sendConfigurationToAPI" class="btn">Speichern</a>

        <a style="margin-top: 10px;" @click="sendConfigurationToAPIAndSwitch" class="btn">Speichern und Vorlage erstellen</a>

    </div>

</template>

<script>
    import AdminBoundingBox from "./../structures/canvas-objects/AdminBoundingBox";
    import requestHelper from "./../api/requestHelper";

    export default {
        name: "BoundingBoxConfigurator",
        data: () => ({
            models: {
                height: null,
                width: null,
                left: 0,
                top: 0,
                maxTop: 0,
                maxLeft: 0,
                factor: null
            },
            level: 1
        }),
        props: {
            /**
             * @type AdminBoundingBox
             */
            boundingBox: {
                type: Object,
                default: () => ({})
            },
            /**
             * @type {{
             *     title: String,
             *     description: String,
             *     printArea: String,
             *     printType: String
             * }}
             */
            view: {
                type: Object,
                default: () => ({
                    id: 0,
                    title: '',
                    description: '',
                    printArea: '',
                    printType: ''
                })
            }
        },
        computed: {
            factor() {
                const canvas = this.boundingBox.getCanvas();
                if (canvas)
                    return canvas.getFactor();
            },

            possibleFactors() {
                // TODO: sinnvolle faktoren bestimmen
                return [
                    { key: '1', value: 1 },
                    { key: '5', value: 5 }
                ];
            }
        },
        methods: {

            rerenderCanvas() {
                if (this.models.factor && this.models.width && this.models.height) {
                    this.boundingBox.setHeight( parseInt( this.models.height * this.models.factor ) );
                    this.boundingBox.setWidth( parseInt( this.models.width * this.models.factor ) );
                    this.boundingBox.getCanvas().setFactor( this.models.factor );
                    this.boundingBox.setLeft(this.models.left * this.models.factor);
                    this.boundingBox.setTop(this.models.top * this.models.factor);
                    this.eventMaxYModified({target: { value: this.models.maxTop }});
                    this.eventMaxXModified({target: { value: this.models.maxLeft }});
                    this.boundingBox.getCanvas().render();
                }

            },

            async sendConfigurationToAPI() {

                const response = await requestHelper.requestApiRoute('patch', `/view/${this.view.id}`, {

                    factor: this.models.factor,
                    boundingBox: {
                        x: {
                            min: this.boundingBox.getMinX(),
                            max: this.boundingBox.getMaxX(),
                            current: this.boundingBox.getMinX()
                        },
                        y: {
                            min: this.boundingBox.getMinY(),
                            max: this.boundingBox.getMaxY(),
                            current: this.boundingBox.getMinY()
                        },
                        sizes: {
                            height: this.models.height * this.models.factor,
                            width: this.models.width * this.models.factor
                        }
                    }

                }, error => { console.log(error) });

                alert('Speichern erfolgreich!');

            },

            async sendConfigurationToAPIAndSwitch() {

                await this.sendConfigurationToAPI();

                this.$emit('changeToBlueprintMode');

            },

            eventHeightModified(e) {
                this.oldHeight = this.boundingBox.getHeight();
                this.boundingBox.setHeight(
                        + e.target.value
                );
                this.rerenderCanvas();
            },

            eventWidthModified(e) {
                this.oldWidth = this.boundingBox.getWidth();
                this.boundingBox.setWidth(
                        + e.target.value
                );
                this.rerenderCanvas();
            },

            eventTopModified(e) {
                // this.boundingBox.y.current = parseInt( e.target.value ) * this.models.factor;
                // this.boundingBox.setTop(parseInt( e.target.value ) * this.models.factor);
                this.models.top = parseInt( e.target.value );
                this.rerenderCanvas();
            },

            eventLeftModified(e) {
                // this.boundingBox.x.current = parseInt( e.target.value ) * this.models.factor;
                // this.boundingBox.setLeft(parseInt( e.target.value ) * this.models.factor);
                this.models.left = parseInt( e.target.value );
                this.rerenderCanvas();
            },

            eventFactorModified(e) {

                console.log({bB: this.boundingBox});
                this.oldFactor = this.boundingBox.getCanvas()._factor;
                this.boundingBox.getCanvas().setFactor(+ e.target.value);
                if (this.oldFactor === 0)
                    this.boundingBox.set({
                        height: this.boundingBox.getHeight() * this.factor,
                        width: this.boundingBox.getWidth() * this.factor,
                        scaleX: 1,
                        scaleY: 1
                    });
                this.rerenderCanvas();

            },

            eventMaxYModified(e) {

                this.models.maxTop = parseInt(e.target.value || 0);

                let maxY = this.boundingBox.getTop() + ( this.models.maxTop * this.models.factor);

                this.boundingBox.setMaxY(
                    parseFloat(maxY)
                );

            },

            eventMaxXModified(e) {

                // this.boundingBox.setMaxX(parseInt(e.target.value));

                this.models.maxLeft = parseInt(e.target.value || 0);

                let maxX = this.boundingBox.getLeft() + ( this.models.maxLeft * this.models.factor);

                this.boundingBox.setMaxX(
                    parseFloat(maxX)
                );

            }

        },
        watch: {
            'boundingBox._left': function () {
                  this.models.left = this.boundingBox.getLeft() / this.factor;
            },
            'boundingBox._top': function () {
                this.models.top = this.boundingBox.getTop() / this.factor;
            }
        },
        mounted() {
            this.models.height = this.boundingBox.getHeight() / this.factor || null;
            this.models.width = this.boundingBox.getWidth() / this.factor || null;
            this.models.factor = this.factor || null;
            this.models.maxTop = (this.boundingBox.getMaxY() - this.boundingBox.getMinY()) / this.factor;
            this.models.left = this.boundingBox.getLeft() / this.factor;
            this.models.top = this.boundingBox.getTop() / this.factor;
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    h3 {
        color: $blue-color;
        margin: 0;
        margin-bottom: 20px;
        font-size: 1.3rem;
    }

    h4 {
        color: $blue-color;
        margin: 40px 0 5px 0;
    }

    p {
        color: $grey-font;
        font-size: 0.9em;
        margin: 0 0 10px 0;
        padding: 0;

        b.display-block {
            display: block;
        }
    }

    label.configure-property {
        display: flex;
        flex-direction: column;
        margin-bottom: .5rem;

        span {
            color: $blue-color;
            font-weight: lighter;
        }

        input {
            box-sizing: border-box;
            border-radius: 5px;
            width: 100%;
            border: 1px solid $grey-font;
            background-color: white;
            padding: 0.5rem;

            &:invalid {
                border: 1px solid $grey-font;
                box-shadow: none;
            }
        }
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;
        background-color: $blue-color;
        color: #ffffff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;

        &.btn-red {
            background-color: #D85846;
        }

        &[disabled=disabled] {
            background-color: darken($grey-font, 20);
            cursor: default;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .btn-fullsize {
        height: 100%;
        width: 100%;
    }

    .select {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid $grey-font;
        border-radius: 5px;
        position: relative;
        background-color: #ffffff;

        select {
            font-size: 0.8rem;
            border-radius: 5px;
            margin: 0;
            padding: 0.6rem 2rem 0.6rem 0.4rem;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::-ms-expand {
                display: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        &::after {
            position: absolute;
            font-family: "Material Icons";
            content: "arrow_drop_down";
            top: 50%;
            margin-top: -.5rem;
            right: .5rem;
            width: 1rem;
            height: 1rem;
            color: $blue-color;
            font-size: 1rem;
        }
    }

</style>